var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsOutlineGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.392,
    height: 22.393,
    viewBox: "0 0 22.392 22.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#50c150;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.658,17.675A1.679,1.679,0,0,0,9.337,16a.862.862,0,0,0,0-.168L12.461,12.7h.515l1.8,1.8v.09a1.679,1.679,0,1,0,3.359,0v-.09L22.213,10.4h0a1.679,1.679,0,1,0-1.679-1.679.862.862,0,0,0,0,.168l-4.042,4.042h-.179l-1.937-1.971a1.679,1.679,0,1,0-3.359,0L7.658,14.316h0a1.679,1.679,0,0,0,0,3.359Zm15.115,4.479H3.739V3.12a1.12,1.12,0,1,0-2.239,0V23.273a1.12,1.12,0,0,0,1.12,1.12H22.773a1.12,1.12,0,0,0,0-2.239Z",
    transform: "translate(-1.5 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsOutlineGreen);
export default __webpack_public_path__ + "static/media/analytics_outline_green.a9dc29cedf6732814073b0892cd0a918.svg";
export { ForwardRef as ReactComponent };